import React from 'react';
import {
    ListItem,
    ListItemText,
    Checkbox,
} from '@mui/material';
import { assetLabelStyle } from '../utils';
import { trakrefBlue } from '../../../color_utils';


const AssetRow = ({
    locationId,
    name,
    setChecked,
    assetId,
    assetIdsForReport,
    asset,
}) => (
    <ListItem
        secondaryAction={
            <>
                <Checkbox
                    checked={assetIdsForReport.includes(assetId)}
                    onChange={e => setChecked(e.target.checked, assetId, locationId)}
                    inputProps={{ 'aria-label': 'controlled' }}
                    sx={{ '&.Mui-checked': { color: trakrefBlue } }}
                />
            </>
        }
    >
        <ListItemText
            primary={name}
            sx={assetLabelStyle}
        />
    </ListItem>
);

export default AssetRow;
